import { gql } from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client';
import {
  ChangeDefaultForecastMutation,
  ChangeDefaultForecastMutationVariables,
  DefaultForecastQuery,
  DefaultForecastQueryVariables,
} from '../../../generated/graphql';

export const defaultForecastQuery: TypedDocumentNode<DefaultForecastQuery, DefaultForecastQueryVariables> = gql`
  query DefaultForecast($deviceId: ID!) {
    getDefaultForecast(deviceId: $deviceId) {
      id
      month
      auxiliaryConsumption {
        value
        unit
      }
      minimum {
        value
        unit
      }
      maximum {
        value
        unit
      }
      forecasts {
        value {
          value
          unit
        }
        interval {
          start
          end
        }
      }
    }
  }
`;

export const defaultForecastMutation: TypedDocumentNode<
  ChangeDefaultForecastMutation,
  ChangeDefaultForecastMutationVariables
> = gql`
  mutation ChangeDefaultForecast($deviceId: ID!, $forecast: [DefaultForecastInput!]!) {
    changeDefaultForecast(deviceId: $deviceId, forecast: $forecast) {
      id
      month
      auxiliaryConsumption {
        value
        unit
      }
      minimum {
        value
        unit
      }
      maximum {
        value
        unit
      }
      forecasts {
        value {
          value
          unit
        }
        interval {
          start
          end
        }
      }
    }
  }
`;
